import {Component, EventEmitter, Input, Output} from '@angular/core';

import {Alert, AlertType} from './alert.model';
import {AlertService} from './alert.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {AbstractSigaleComponent} from '../abstract-sigale.component';

@Component({
	standalone: true,
	selector: 'alert',
	templateUrl: 'alert.component.html',
	styleUrls: ['./alert.component.scss'],
	imports: [
		CommonModule,
		TranslateModule
	]
})

export class AlertComponent extends AbstractSigaleComponent {
	alerts: Alert[] = [];
	@Input('nom') nom: string = 'main'; //le nom logique du composant
	@Input('nomBouton') nomBouton: string = 'GLOBAL.BTN_OK'; //le nom du bouton
	@Input('nomBouton2') nomBouton2: string = '';
	@Input('loading') loading = false;
	@Output('onClose') onCloseListener: EventEmitter<any> = new EventEmitter<any>();

	constructor(private alertService: AlertService) {
		super();
	}

	ngOnInit() {
		super.ngOnInit();
		this.alertService.getAlert().subscribe((alert: Alert) => {
			// si pas de nom et que la demande de suppression est faite, on efface tous les messages d'erreur, peu importe où se trouve le composant.
			if (!alert.nom) {
				if (alert.clear) {
					this.alerts = [];
				}
				return;
			}

			// si le composant alerte actuellement inspecté n'est pas le bon, alors on quitte sans rien faire.
			if (alert.nom !== this.nom) {
				return;
			}

			if (alert.clear) {
				this.alerts = [];
				return;
			}

			// add alert to array
			this.alerts.push(alert);
			if (!alert.keep) {
				setTimeout(() => {
					let index = this.alerts.indexOf(alert);
					if (index > -1) {
						this.alerts.splice(index, 1);
					}
				}, 5000);
			}
		});
	}

	removeAlert(alert: Alert) {
		this.onCloseListener.emit();
		this.alerts = this.alerts.filter(x => x !== alert);
	}

	cssClass(alert: Alert) {
		if (!alert) {
			return;
		}

		// return css class based on alert type
		switch (alert.type) {
			case AlertType.Success:
				return 'alert alert-success';
			case AlertType.Error:
				return 'alert alert-error alert-danger';
			case AlertType.Info:
				return 'alert alert-info';
			case AlertType.Warning:
				return 'alert alert-warning';
		}
	}

	onClickFunction(alert: Alert) {
		alert.onClickFunction(...alert.functionArguments);
	}

	onClickFunctionBouton2(alert: Alert) {
		alert.onClickFunctionBouton2(...alert.functionArgumentsBouton2);
	}
}
